import { debounce } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import ym from 'react-yandex-metrika'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { baseURLImage } from '../../../api/api'
import { isMobile } from '../../../helpers/isMobile'
import { getProject } from '../../../store/project/project'
import { PlanType } from '../../../store/project/types'
import { Button } from '../../UI/Button/Button'
import style from './ProjectApartmentLayout.module.scss'

interface ProjectApartmentLayoutTypes {
  plans: PlanType[]
  id: string | undefined
}

const ProjectApartmentLayout = ({ plans, id }: ProjectApartmentLayoutTypes) => {
  const [isMob, setIsMob] = useState(isMobile())
  const { project } = useSelector(getProject)
  const [tabActiveIndex, setTabActiveIndex] = useState<number>(0)
  const navigate = useNavigate()

  const resize = debounce(() => {
    setIsMob(isMobile())
  }, 200)

  useEffect(() => {
    setTabActiveIndex(0)
  }, [project])

  useEffect(() => {
    window.addEventListener('resize', resize)

    return () => window.removeEventListener('resize', resize)
  }, [])
  // console.log(plans)
  return (
    <div className='ProjectApartmentLayout'>
      <h2>Планировки</h2>
      <div className={style.wrapper}>
        <Tabs
          // forceRenderTabPanel={true}
          selectedTabClassName={`${style['tabs-button--active']}`}
          selectedIndex={tabActiveIndex}
          onSelect={index => {
            setTabActiveIndex(() => index)
          }}
        >
          {plans.map((el, index) => (
            <TabPanel key={index}>
              {isMob && (
                <Swiper
                  modules={[Navigation]}
                  navigation={true}
                  className={style.slider}
                  centeredSlides={true}
                  speed={500}
                  slidesPerView={1}
                  spaceBetween={50}
                >
                  {el.items.map((object, j) => (
                    <SwiperSlide className={style.slider__slide} key={j}>
                      <img src={`${baseURLImage}${object.SRC}`} alt='' />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
              {!isMob && (
                <div className='row'>
                  {el.items.map((object, j) => (
                    <div className={style.slider__slide} key={j}>
                      <img src={`${baseURLImage}${object.SRC}`} alt='' />
                    </div>
                  ))}
                </div>
              )}
              <div className={style.ProjectApartmentLayout__button}>
                <Button
                  onClick={() => {
                    navigate(`/flats/${id}?rooms=${el.type}`)
                  }}
                  content={'Cмотреть квартиры'}
                ></Button>
              </div>
            </TabPanel>
          ))}
          <div className={style['tabs-row']}>
            <TabList className={style['tabs-list']}>
              {plans.map((el, index) => (
                <Tab
                  key={index}
                  className={`
                ${style['tabs-button']}
                ${el.type === 'studio' ? style['tabs-button--big'] : ''}
              `}
                >
                  <span>{el.type === 'studio' ? 'Студия' : el.type}</span>
                </Tab>
              ))}
            </TabList>
          </div>
        </Tabs>
      </div>
    </div>
  )
}

export default ProjectApartmentLayout
